import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = { withCredentials: true };

export const submitEnquiry = (payload) =>
  axios.post(`${API}/enquiries`, payload).then((r) => r.data);

export const fetchEnquiries = (adminKey) =>
  axios
    .get(`${API}/enquiries`, { headers: { "X-Admin-Key": adminKey }, withCredentials: true })
    .then((r) => r.data);

export const setEnquiryStatus = (adminKey, id, status) =>
  axios
    .put(`${API}/admin/enquiries/${id}/status`, { status }, { headers: { "X-Admin-Key": adminKey }, withCredentials: true })
    .then((r) => r.data);

export const deleteEnquiry = (adminKey, id) =>
  axios
    .delete(`${API}/admin/enquiries/${id}`, { headers: { "X-Admin-Key": adminKey }, withCredentials: true })
    .then((r) => r.data);

export const formatApiError = (e) => {
  const detail = e.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
};

export const uploadDocument = (file, checklistKey = "") => {
  const fd = new FormData();
  fd.append("file", file);
  if (checklistKey) fd.append("checklist_key", checklistKey);
  return axios.post(`${API}/documents`, fd, auth).then((r) => r.data);
};

export const fetchDocuments = () => axios.get(`${API}/documents`, auth).then((r) => r.data);

export const deleteDocument = (id) => axios.delete(`${API}/documents/${id}`, auth).then((r) => r.data);

export const downloadDocument = async (doc) => {
  const r = await axios.get(`${API}/documents/${doc.id}/download`, { ...auth, responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = doc.original_filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const fetchChecklist = () => axios.get(`${API}/portal/checklist`, auth).then((r) => r.data);

export const saveChecklist = (checked, incomeTypes = []) =>
  axios.put(`${API}/portal/checklist`, { checked, income_types: incomeTypes }, auth).then((r) => r.data);

export const mfaVerify = (code) => axios.post(`${API}/auth/mfa/verify`, { code }, auth).then((r) => r.data);
export const mfaEnroll = () => axios.post(`${API}/auth/mfa/enroll`, {}, auth).then((r) => r.data);
export const mfaConfirm = (code) => axios.post(`${API}/auth/mfa/enroll/confirm`, { code }, auth).then((r) => r.data);
export const mfaDisable = (code, password) =>
  axios.post(`${API}/auth/mfa/disable`, { code, password }, auth).then((r) => r.data);

export const fetchFees = () => axios.get(`${API}/fees`).then((r) => r.data);

export const saveFees = (adminKey, fees) =>
  axios.put(`${API}/admin/fees`, fees, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const fetchClients = (adminKey) =>
  axios.get(`${API}/admin/clients`, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const fetchTosAcceptances = (adminKey) =>
  axios.get(`${API}/admin/tos-acceptances`, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const createClientFromInterview = (adminKey, payload) =>
  axios.post(`${API}/admin/clients`, payload, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const previewWelcomeEmail = (adminKey, payload) =>
  axios.post(`${API}/admin/clients/preview-welcome`, payload, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const updateClientProfile = (adminKey, userId, payload) =>
  axios.put(`${API}/admin/clients/${userId}/profile`, payload, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const sendClientEstimate = (adminKey, userId) =>
  axios.post(`${API}/admin/clients/${userId}/send-estimate`, {}, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

const adminHeaders = (adminKey) => ({ headers: { "X-Admin-Key": adminKey }, withCredentials: true });

export const fetchSatisfaction = () => axios.get(`${API}/satisfaction`, auth).then((r) => r.data);

export const saveSatisfaction = (payload) => axios.post(`${API}/satisfaction`, payload, auth).then((r) => r.data);

export const stripeDiagnostics = (adminKey) =>
  axios.get(`${API}/admin/stripe-diagnostics`, adminHeaders(adminKey)).then((r) => r.data);

export const fetchNotifications = (adminKey) =>
  axios.get(`${API}/admin/notifications`, adminHeaders(adminKey)).then((r) => r.data);

export const readAllNotifications = (adminKey) =>
  axios.post(`${API}/admin/notifications/read-all`, {}, adminHeaders(adminKey)).then((r) => r.data);

export const dismissNotification = (adminKey, id) =>
  axios.post(`${API}/admin/notifications/${id}/dismiss`, {}, adminHeaders(adminKey)).then((r) => r.data);

export const dismissAllNotifications = (adminKey) =>
  axios.post(`${API}/admin/notifications/dismiss-all`, {}, adminHeaders(adminKey)).then((r) => r.data);

export const publicSignup = (payload) => axios.post(`${API}/signup`, payload).then((r) => r.data);

export const verifyAddress = (address) =>
  axios.post(`${API}/address/verify`, { address }).then((r) => r.data);

export const fetchOnboarding = () => axios.get(`${API}/onboarding`, auth).then((r) => r.data);

export const submitOnboarding = (payload) => axios.post(`${API}/onboarding`, payload, auth).then((r) => r.data);

export const requestClientInfo = (adminKey, userId) =>
  axios.post(`${API}/admin/clients/${userId}/request-info`, {}, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const deleteClient = (adminKey, userId) =>
  axios.delete(`${API}/admin/clients/${userId}`, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const resendWelcomeEmail = (adminKey, userId) =>
  axios.post(`${API}/admin/clients/${userId}/resend-welcome`, {}, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const emailDiagnostics = (adminKey) =>
  axios.get(`${API}/admin/email-diagnostics`, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const changePassword = (currentPassword, newPassword) =>
  axios.post(`${API}/auth/change-password`, { current_password: currentPassword, new_password: newPassword }, auth).then((r) => r.data);

export const fetchMessages = () => axios.get(`${API}/messages`, auth).then((r) => r.data);

export const sendMessage = (body) => axios.post(`${API}/messages`, { body }, auth).then((r) => r.data);

export const fetchActivity = () => axios.get(`${API}/portal/activity`, auth).then((r) => r.data);

export const fetchClientMessages = (adminKey, userId) =>
  axios.get(`${API}/admin/clients/${userId}/messages`, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const sendClientMessage = (adminKey, userId, body) =>
  axios.post(`${API}/admin/clients/${userId}/messages`, { body }, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const fetchClientActivity = (adminKey, userId) =>
  axios.get(`${API}/admin/clients/${userId}/activity`, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const fetchStatus = () => axios.get(`${API}/portal/status`, auth).then((r) => r.data);

export const adminSetStatus = (adminKey, userId, stage) =>
  axios.put(`${API}/admin/clients/${userId}/status`, { stage }, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const adminGetChecklist = (adminKey, userId) =>
  axios.get(`${API}/admin/clients/${userId}/checklist`, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const adminRequestItem = (adminKey, userId, text) =>
  axios.post(`${API}/admin/clients/${userId}/checklist-items`, { text }, { headers: { "X-Admin-Key": adminKey }, withCredentials: true }).then((r) => r.data);

export const adminDownloadDocument = async (adminKey, doc) => {
  const r = await axios.get(`${API}/admin/documents/${doc.id}/download`, {
    headers: { "X-Admin-Key": adminKey },
    withCredentials: true,
    responseType: "blob",
  });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = doc.original_filename;
  a.click();
  URL.revokeObjectURL(url);
};

// Fetch a document as an object URL for inline preview (image/PDF viewer).
// Caller is responsible for revoking the URL when done.
export const adminDocumentPreviewUrl = async (adminKey, doc) => {
  const r = await axios.get(`${API}/admin/documents/${doc.id}/download`, {
    headers: { "X-Admin-Key": adminKey },
    withCredentials: true,
    responseType: "blob",
  });
  return URL.createObjectURL(r.data);
};

const adminOpts = (adminKey) => ({ headers: { "X-Admin-Key": adminKey }, withCredentials: true });

export const fetchInvoices = (adminKey) =>
  axios.get(`${API}/admin/invoices`, adminOpts(adminKey)).then((r) => r.data);

export const fetchMobileInvoice = (key, id) =>
  axios.get(`${API}/admin/mobile-invoices/${id}`, adminOpts(key)).then((r) => r.data);
export const signMobileInvoice = (key, id, payload) =>
  axios.post(`${API}/admin/mobile-invoices/${id}/sign`, payload, adminOpts(key)).then((r) => r.data);
export const checkoutMobileInvoice = (key, id) =>
  axios.post(`${API}/admin/mobile-invoices/${id}/checkout`, { origin_url: window.location.origin }, adminOpts(key)).then((r) => r.data);
export const resetMobileInvoice = (key, id) =>
  axios.post(`${API}/admin/mobile-invoices/${id}/reset`, {}, adminOpts(key)).then((r) => r.data);
export const retryMobileReceipt = (key, id) =>
  axios.post(`${API}/admin/mobile-invoices/${id}/receipt/retry`, {}, adminOpts(key)).then((r) => r.data);
export const downloadMobileReceipt = async (key, invoice) => {
  const r = await axios.get(`${API}/admin/mobile-invoices/${invoice.id}/receipt.pdf`, { ...adminOpts(key), responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${invoice.number}-paid.pdf`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const createInvoice = (adminKey, payload) =>
  axios.post(`${API}/admin/invoices`, payload, adminOpts(adminKey)).then((r) => r.data);

export const updateInvoice = (adminKey, id, payload) =>
  axios.put(`${API}/admin/invoices/${id}`, payload, adminOpts(adminKey)).then((r) => r.data);

export const setInvoiceStatus = (adminKey, id, status) =>
  axios.put(`${API}/admin/invoices/${id}/status`, { status }, adminOpts(adminKey)).then((r) => r.data);

export const sendInvoiceLink = (adminKey, id) =>
  axios.post(`${API}/admin/invoices/${id}/send-link`, {}, adminOpts(adminKey)).then((r) => r.data);

export const getPayToken = (adminKey, id) =>
  axios.post(`${API}/admin/invoices/${id}/pay-token`, {}, adminOpts(adminKey)).then((r) => r.data);

// Scheduling — public
export const fetchConsultationTypes = () =>
  axios.get(`${API}/consultation-types`).then((r) => r.data);
export const fetchAvailability = (typeId, day) =>
  axios.get(`${API}/availability`, { params: { type_id: typeId, day } }).then((r) => r.data);
export const createBooking = (payload) =>
  axios.post(`${API}/bookings`, payload).then((r) => r.data);
export const submitMessageBooking = (payload) =>
  axios.post(`${API}/bookings/message`, payload).then((r) => r.data);
export const fetchBookingBySession = (sessionId) =>
  axios.get(`${API}/bookings/session/${sessionId}`).then((r) => r.data);

// Scheduling — admin
export const adminListTypes = (k) =>
  axios.get(`${API}/admin/consultation-types`, adminOpts(k)).then((r) => r.data);
export const adminCreateType = (k, p) =>
  axios.post(`${API}/admin/consultation-types`, p, adminOpts(k)).then((r) => r.data);
export const adminUpdateType = (k, id, p) =>
  axios.put(`${API}/admin/consultation-types/${id}`, p, adminOpts(k)).then((r) => r.data);
export const adminDeleteType = (k, id) =>
  axios.delete(`${API}/admin/consultation-types/${id}`, adminOpts(k)).then((r) => r.data);
export const adminGetSchedulingConfig = (k) =>
  axios.get(`${API}/admin/scheduling-config`, adminOpts(k)).then((r) => r.data);
export const adminSetSchedulingConfig = (k, p) =>
  axios.put(`${API}/admin/scheduling-config`, p, adminOpts(k)).then((r) => r.data);
export const adminListBookings = (k) =>
  axios.get(`${API}/admin/bookings`, adminOpts(k)).then((r) => r.data);
export const adminSetBookingStatus = (k, id, status) =>
  axios.put(`${API}/admin/bookings/${id}/status`, { status }, adminOpts(k)).then((r) => r.data);
export const adminDeleteBooking = (k, id) =>
  axios.delete(`${API}/admin/bookings/${id}`, adminOpts(k)).then((r) => r.data);
export const adminBookingAvailability = (k, id, day) =>
  axios.get(`${API}/admin/bookings/${id}/availability`, { params: { day }, ...adminOpts(k) }).then((r) => r.data);
export const adminRescheduleBooking = (k, id, start) =>
  axios.put(`${API}/admin/bookings/${id}/reschedule`, { start }, adminOpts(k)).then((r) => r.data);
export const adminRequestBookingPayment = (k, id) =>
  axios.post(`${API}/admin/bookings/${id}/request-payment`, {}, adminOpts(k)).then((r) => r.data);
export const fetchBookingPay = (token) =>
  axios.get(`${API}/book/pay/${token}`).then((r) => r.data);
export const checkoutBookingPay = (token) =>
  axios.post(`${API}/book/pay/${token}/checkout`, { origin_url: window.location.origin }).then((r) => r.data);

export const fetchPayInvoice = (token) =>
  axios.get(`${API}/pay/${token}`).then((r) => r.data);
export const signPayInvoice = (token, payload) =>
  axios.post(`${API}/pay/${token}/sign`, payload).then((r) => r.data);
export const checkoutPayInvoice = (token) =>
  axios.post(`${API}/pay/${token}/checkout`, { origin_url: window.location.origin }).then((r) => r.data);

export const deleteInvoice = (adminKey, id) =>
  axios.delete(`${API}/admin/invoices/${id}`, adminOpts(adminKey)).then((r) => r.data);

export const convertEstimate = (adminKey, id) =>
  axios.post(`${API}/admin/invoices/${id}/convert`, {}, adminOpts(adminKey)).then((r) => r.data);

export const signInvoice = (id, payload) =>
  axios.post(`${API}/portal/invoices/${id}/sign`, payload, auth).then((r) => r.data);

export const payInvoice = (id, originUrl) =>
  axios.post(`${API}/portal/invoices/${id}/pay`, { origin_url: originUrl }, auth).then((r) => r.data);

export const getPaymentStatus = (sessionId) =>
  axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data);


export const fetchMyInvoices = () => axios.get(`${API}/portal/invoices`, auth).then((r) => r.data);

// Payroll — unified (admin passes key; client passes nothing → cookie auth)
const payrollOpts = (k) => (k ? { headers: { "X-Admin-Key": k }, withCredentials: true } : { withCredentials: true });
export const payrollMeta = (k) => axios.get(`${API}/payroll/meta`, payrollOpts(k)).then((r) => r.data);
export const payrollCompanies = (k) => axios.get(`${API}/payroll/companies`, payrollOpts(k)).then((r) => r.data);
export const payrollCreateCompany = (k, p) => axios.post(`${API}/payroll/companies`, p, payrollOpts(k)).then((r) => r.data);
export const payrollCompany = (k, id) => axios.get(`${API}/payroll/companies/${id}`, payrollOpts(k)).then((r) => r.data);
export const payrollUpdateCompany = (k, id, p) => axios.put(`${API}/payroll/companies/${id}`, p, payrollOpts(k)).then((r) => r.data);
export const payrollDeleteCompany = (k, id) => axios.delete(`${API}/payroll/companies/${id}`, payrollOpts(k)).then((r) => r.data);
export const payrollGrantAccess = (k, id, p) => axios.post(`${API}/payroll/companies/${id}/access`, p, payrollOpts(k)).then((r) => r.data);
export const payrollRevokeAccess = (k, id, uid) => axios.delete(`${API}/payroll/companies/${id}/access/${uid}`, payrollOpts(k)).then((r) => r.data);
export const payrollAddEmployee = (k, id, p) => axios.post(`${API}/payroll/companies/${id}/employees`, p, payrollOpts(k)).then((r) => r.data);
export const payrollUpdateEmployee = (k, id, p) => axios.put(`${API}/payroll/employees/${id}`, p, payrollOpts(k)).then((r) => r.data);
export const payrollDeleteEmployee = (k, id) => axios.delete(`${API}/payroll/employees/${id}`, payrollOpts(k)).then((r) => r.data);
export const payrollPreviewRun = (k, id, p) => axios.post(`${API}/payroll/companies/${id}/payruns/preview`, p, payrollOpts(k)).then((r) => r.data);
export const payrollCreateRun = (k, id, p) => axios.post(`${API}/payroll/companies/${id}/payruns`, p, payrollOpts(k)).then((r) => r.data);
export const payrollListRuns = (k, id) => axios.get(`${API}/payroll/companies/${id}/payruns`, payrollOpts(k)).then((r) => r.data);
export const payrollGetRun = (k, id) => axios.get(`${API}/payroll/payruns/${id}`, payrollOpts(k)).then((r) => r.data);
export const payrollApproveRun = (k, id) => axios.post(`${API}/payroll/payruns/${id}/approve`, {}, payrollOpts(k)).then((r) => r.data);
export const payrollPostRun = (k, id) => axios.post(`${API}/payroll/payruns/${id}/post`, {}, payrollOpts(k)).then((r) => r.data);
export const payrollPayRun = (k, id, body) => axios.post(`${API}/payroll/payruns/${id}/pay`, body, payrollOpts(k)).then((r) => r.data);
export const payrollVoidRun = (k, id) => axios.post(`${API}/payroll/payruns/${id}/void`, {}, payrollOpts(k)).then((r) => r.data);
export const payrollDeleteRun = (k, id) => axios.delete(`${API}/payroll/payruns/${id}`, payrollOpts(k)).then((r) => r.data);
export const payrollReport941 = (k, id, year, quarter) => axios.get(`${API}/payroll/companies/${id}/reports/941`, { params: { year, quarter }, ...payrollOpts(k) }).then((r) => r.data);
export const payrollReport940 = (k, id, year) => axios.get(`${API}/payroll/companies/${id}/reports/940`, { params: { year }, ...payrollOpts(k) }).then((r) => r.data);
export const payrollReportW2 = (k, id, year) => axios.get(`${API}/payroll/companies/${id}/reports/w2`, { params: { year }, ...payrollOpts(k) }).then((r) => r.data);
export const payrollFilings = (k, id, year) => axios.get(`${API}/payroll/companies/${id}/filings`, { params: { year }, ...payrollOpts(k) }).then((r) => r.data);
export const payrollMarkFiling = (k, p) => axios.post(`${API}/payroll/filings/mark`, p, payrollOpts(k)).then((r) => r.data);
export const payrollLiabilities = (k, id, year) => axios.get(`${API}/payroll/companies/${id}/liabilities`, { params: { year }, ...payrollOpts(k) }).then((r) => r.data);
export const payrollListPayments = (k, id, year) => axios.get(`${API}/payroll/companies/${id}/payments`, { params: { year }, ...payrollOpts(k) }).then((r) => r.data);
export const payrollRecordPayment = (k, id, p) => axios.post(`${API}/payroll/companies/${id}/payments`, p, payrollOpts(k)).then((r) => r.data);
export const payrollDeletePayment = (k, pid) => axios.delete(`${API}/payroll/payments/${pid}`, payrollOpts(k)).then((r) => r.data);
export const payrollCalendar = (k, id, year) => axios.get(`${API}/payroll/companies/${id}/calendar`, { params: { year }, ...payrollOpts(k) }).then((r) => r.data);

